import { cva } from '@vizit/theme';

const containerClasses = cva({
  base: 'flex flex-col justify-between px-8 pb-3 pt-6 h-[163px] transition-all duration-[350ms]',
  variants: {
    state: {
      default: 'bg-primary',
      focused: 'bg-primary shadow-lg',
      disabled: '',
    },
  },
  defaultVariants: {
    state: 'default',
  },
});

const countColorMap = {
  success: { default: 'text-fg-success-secondary', disabled: 'text-success-200' },
  warning: { default: 'text-fg-warning-secondary', disabled: 'text-warning-200' },
} as const;

function getCountColor(status: 'success' | 'warning', isDisabled: boolean): string {
  return countColorMap[status][isDisabled ? 'disabled' : 'default'];
}

export { containerClasses, getCountColor };
